import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IMessagingSender, IMessaging, NurseDashbordAttachments, MessageInbox, messengerPatientsInfo, ReceiveMessengerInfo, chatMessengerInfo } from 'src/app/models/IMessaging';
import { IMessagetype } from 'src/app/models/IMessagetype';
import { IUserDetails } from 'src/app/models/IUsersDetails';
//var Configuration = require('src/assets/app-config.json');
import { configuration } from 'src/environments/environment';
import { directmessageDTO } from 'src/app/models/IPharmacyDirectory';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  temppage: number = 0;
  pageField = [];
  exactPageList: any;

  constructor(private http: HttpClient) { }

  insertSenderMessageDetails(messaging: IMessaging, userid: string): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(messaging)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/MessagesSend'}?userid=${userid}&&locId=${Number(sessionStorage.getItem("LocationId"))}&&portal=null`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getAllMessageTypes(): Observable<IMessagetype[]> {
    return this.http.get<IMessagetype[]>(
      `${configuration.clinicapiUrl + 'Encounter/allMessageType'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  getAllUsers(): Observable<IUserDetails[]> {
    return this.http.get<IUserDetails[]>(
      `${configuration.clinicapiUrl + 'Encounter/allUsers'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&facilityid=${sessionStorage.getItem("FacilityId")}`);
  }

  getAllMessages(userId: string, alllocId: any, activeStatus?: boolean): Observable<IMessagingSender[]> {
    return this.http.get<IMessagingSender[]>(
      `${configuration.clinicapiUrl + 'Encounter/allMessageInbox'}?userid=${encodeURIComponent(userId).toString()}&&locId=${alllocId}&&facId=${Number(sessionStorage.getItem('FacilityId'))}&&activeStatus=${activeStatus}&&portal=null`);
  }
  getMessagebySenderId(senderid: number): Observable<IMessagingSender> {
    return this.http.get<IMessagingSender>(
      `${configuration.clinicapiUrl + 'Encounter/Message'}?senderId=${senderid}`);
  }
  getAllERxMessageTypes(): Observable<IMessagetype[]> {
    return this.http.get<IMessagetype[]>(
      `${configuration.clinicapiUrl + 'Encounter/allERXMessageType'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  getAllMessagesPagination(userId: string, alllocId: any, pageNum: number, PageSize: number, searchOrder: any, activeStatus?: boolean): Observable<IMessagingSender[]> {
    return this.http.get<IMessagingSender[]>(
      `${configuration.clinicapiUrl + 'Encounter/allMessageInboxPagination'}?userid=${encodeURIComponent(userId).toString()}&&locId=${alllocId}&&activeStatus=${activeStatus}&&portal=null&&pageNum=${pageNum}&&PageSize=${PageSize}&&searchOrder=${searchOrder}`);
  }
  GetUsersAllMessages(allLoc: any): Observable<IMessagingSender[]> {
    return this.http.get<IMessagingSender[]>(
      `${configuration.clinicapiUrl + 'Encounter/allUserMessage'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&locId=${allLoc}&&facId=${Number(sessionStorage.getItem('FacilityId'))}`);
  }

  getAssignToMessages(userId: string): Observable<IMessagingSender[]> {
    return this.http.get<IMessagingSender[]>(
      `${configuration.clinicapiUrl + 'Encounter/assignToMessageInbox'}?userid=${encodeURIComponent(userId).toString()}&&locId=${Number(sessionStorage.getItem("LocationId"))}&&portal=null`);
  }

  pageOnLoad() {
    if (this.temppage == 0) {
      this.pageField = [];
      for (var a = 0; a < this.exactPageList; a++) {
        this.pageField[a] = this.temppage + 1;
        this.temppage = this.temppage + 1;
      }
    }
  }
  //****** Patient Portal Inbox Message Request */

  getAllMessagesRequestByPatientPortal(userId: string): Observable<MessageInbox[]> {
    return this.http.get<MessageInbox[]>(
      `${configuration.clinicapiUrl + 'Encounter/PatientPortalInboxMessagesRequest'}?userid=${encodeURIComponent(userId).toString()}`);
  }

  getDirectMessages(): Observable<directmessageDTO[]> {
    return this.http.get<directmessageDTO[]>(
      `${configuration.clinicapiUrl + 'SureScripts/DirectMessagesInfo'}?userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&locationId=${Number(sessionStorage.getItem("LocationId"))}`);
  }

  getDirectMessagesInfo(messageId: number): any {
    return this.http.get<any>(
      `${configuration.clinicapiUrl + 'SureScripts/DirectMessages'}?msgId=${messageId}&&locationId=${Number(sessionStorage.getItem("LocationId"))}`);
  }

  getAllmessengersPatInfo(): Observable<messengerPatientsInfo[]> {
    return this.http.get<messengerPatientsInfo[]>(
      `${configuration.apiUrl + 'Scheduler/MessengersPatientDetails'}?LocationId=${sessionStorage.getItem("LocationId")}`);
  }

  getPendingmessengersPatInfo(): Observable<messengerPatientsInfo[]> {
    return this.http.get<messengerPatientsInfo[]>(
      `${configuration.apiUrl + 'Scheduler/PendingMessengersPatDetails'}?LocationId=${sessionStorage.getItem("LocationId")}`);
  }

  getReceiveMessengersPatInfo(phoneNo: string, patientId: number): Observable<ReceiveMessengerInfo[]> {
    return this.http.get<ReceiveMessengerInfo[]>(
      `${configuration.apiUrl + 'Scheduler/ReceiveMessengersDetails'}?phoneNo=${phoneNo}&&patientId=${patientId}`);
  }

  insertMessengersPatInfo(patientMessaenger: chatMessengerInfo): Observable<chatMessengerInfo> {
    const posteddata = {
      inputdata: JSON.stringify(patientMessaenger)
    }
    return this.http.post<chatMessengerInfo>(`${configuration.apiUrl + 'Scheduler/InsertPatientMessages'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getSenderMessageInfo(phoneNo: string, patientId: number): Observable<chatMessengerInfo[]> {
    return this.http.get<chatMessengerInfo[]>(
      `${configuration.apiUrl + 'Scheduler/SenderMessageDetails'}?phoneNo=${phoneNo}&&patientId=${patientId}`);
  }

  ValidateDirectCDAMessage(dmsgId: string): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/ValidateCCDADM'}?dmid=${dmsgId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getCDATOHTMLDetails(messaging: any): Observable<string> {
    const posteddata = {
      inputdata: JSON.stringify(messaging)
    }
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/CDATOHTML'}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  UpdateIsReadedDMInfo(msgId: number): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'SureScripts/UpdateIsReadedDM'}?msgId=${msgId}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
}
